import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import ErrorBoundary from './components/ErrorBoundary'

import './styles/main.css'

const container = document.getElementById('app')
if (!container) {
  console.error('App container not found!')
} else {
  const root = createRoot(container)
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  )
}
